// ======================================================================
// File Name       : modal
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { MODAL_OPEN_MODAL, MODAL_HIDE_MODAL, SHOW_HINT_MODAL } from '../constants/actionTypes/modal';

const initialState = {
  modalId: null,
  showHintModal: false,
};

export default function modal(state = initialState, action) {
  switch (action.type) {
    case MODAL_OPEN_MODAL: {
      const { modalId = null } = action;
      return {
        ...state,
        modalId,
      };
    }

    case MODAL_HIDE_MODAL:
      return {
        ...state,
        modalId: null,
      };
    case SHOW_HINT_MODAL: {
      const { showHintModal } = action;
      return {
        ...state,
        showHintModal,
      };
    }
    default:
      return state;
  }
}
